import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSliderImages } from '../../redux/slicer/homeSlicer';
import { BsChevronCompactLeft, BsChevronCompactRight } from 'react-icons/bs';

function Carousel() {
  const dispatch = useDispatch();
  const { images, loading, error } = useSelector((state) => state.home.slider);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Fetch images on component mount
  useEffect(() => {
    dispatch(fetchSliderImages());
  }, [dispatch]);

  // Set the current index to 0 once images are fetched
  useEffect(() => {
    if (images.length > 0) {
      setCurrentIndex(0);
    }
  }, [images]);

  // Preload next and previous images for faster transition
  useEffect(() => {
    if (images.length > 0) {
      const nextIndex = (currentIndex + 1) % images.length;
      const prevIndex = (currentIndex - 1 + images.length) % images.length;
      const nextImage = new Image();
      const prevImage = new Image();
      nextImage.src = images[nextIndex]?.image_url;
      prevImage.src = images[prevIndex]?.image_url;
    }
  }, [currentIndex, images]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(interval);
  }, [currentIndex, images]); // Restart interval when slide changes or images are loaded

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="relative max-w-full mx-auto overflow-hidden">
      {/* Image Slider */}
      <div className="relative w-full h-[550px]">
        {images.length > 0 ? (
          images.map((image, index) => (
            <img
              key={index}
              src={image.image_url}
              alt={`carousel-slide-${index}`}
              loading="lazy"
              className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out ${
                index === currentIndex ? 'opacity-100' : 'opacity-0'
              }`}
            />
          ))
        ) : (
          <div className="flex items-center justify-center h-full text-white text-2xl">
            No images available.
          </div>
        )}

        {/* Caption */}
        <div className="absolute inset-0 flex flex-col justify-center items-center text-white bg-black bg-opacity-40 text-center">
          <h2 className="text-6xl font-bold font-titillium"></h2>
          <p className="text-lg mt-4 font-Inter">{images[currentIndex]?.caption}</p>
        </div>
      </div>

      {/* Navigation Arrows */}
      <button
        className="absolute top-1/2 left-5 transform -translate-y-1/2 text-white text-4xl cursor-pointer z-10"
        onClick={prevSlide}
      >
        <BsChevronCompactLeft />
      </button>
      <button
        className="absolute top-1/2 right-5 transform -translate-y-1/2 text-white text-4xl cursor-pointer z-10"
        onClick={nextSlide}
      >
        <BsChevronCompactRight />
      </button>

      {/* Dots Navigation */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {images.map((_, slideIndex) => (
          <div
            key={slideIndex}
            onClick={() => goToSlide(slideIndex)}
            className={`w-3 h-3 rounded-full cursor-pointer ${
              slideIndex === currentIndex ? 'bg-white' : 'border-2 border-white'
            }`}
          ></div>
        ))}
      </div>
    </div>
  );
}

export default Carousel;
